import type { Region } from '@/modules/region/domain/Region';
import { capitalizeString } from '@/modules/shared/utils/capitalizeString';
import type { Option } from '@/sections/shared/types/Option';

import useCommunes from './useCommunes';

const useCommunesOptions = (id: Region['id']): Option[] => {
  const { data } = useCommunes(id);

  return data
    .map(({ code, name }) => ({
      value: code,
      label: capitalizeString(name)
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export default useCommunesOptions;
